<div class="col-span-2 bg-white dark:bg-[#252c5f]">
    <div class="flex justify-start w-full">

        <div class="w-full">

            <div class="flex items-center mb-[3.25rem]">

              <div class="max-w-24 max-h-24 w-24 h-24 mr-6">

                <!-- Profile Image -->
                <img class="w-full rounded-full cursor-pointer"
                     [src]="report.person_avatar"
                     (error)="onImageError($event)"
                     (load)="onImageLoad()"
                     *ngIf="!isImageError; else errorImage"
                     (click)="showImagePopup(report.person_avatar)"
                     alt="">

                <ng-template #errorImage>
                  <!--
                  <img class="w-full mb-6" src="assets/images/human.svg" alt="">
                  -->
                  <img class="w-full rounded-full" src="https://ui-avatars.com/api/?background=FFA500&color=fff&rounded=true&name={{reportSearch.name}}&format=svg&size=128">
                </ng-template>

              </div>

              <div>
                <div class="w-full">
                  <div class="flex justify-between">
                    <h3 class="text-xl font-semibold leading-6 text-secondary-900 dark:text-white mr-2">{{ report.person_full_name }}</h3>
                    <button type="button" (click)="expandPerson(false)" class="block lg:hidden">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="text-gray-500 size-6">
                        <path d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z" />
                      </svg>
                    </button>
                  </div>

                  <div class="flex">
                    <p class="text-sm text-[#3c4377] dark:text-primary-200">{{ report.person_city ? report.person_city + ',' : '' }} {{ report.person_state ? report.person_state + ',' : '' }} {{ report.person_country }}</p>
                  </div>

                  <p class="text-sm text-secondary dark:text-primary-200">{{ report.person_job_title }}</p>
                </div>

                <!--
                <button (click)="expandPerson(false)" class="text-gray-300 dark:text-white">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
                -->
              </div>

            </div>

            <!--
            <div class="flex justify-start items-center space-x-3 mb-3">

              <div>
                <div class="flex justify-center items-center">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="text-secondary dark:text-primary-200 size-6 mr-2">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M21.75 6.75v10.5a2.25 2.25 0 0 1-2.25 2.25h-15a2.25 2.25 0 0 1-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25m19.5 0v.243a2.25 2.25 0 0 1-1.07 1.916l-7.5 4.615a2.25 2.25 0 0 1-2.36 0L3.32 8.91a2.25 2.25 0 0 1-1.07-1.916V6.75" />
                  </svg>
                  <span class="flex justify-center items-center text-xs h-7 w-7 bg-[#DFE0FF]/10 border border-[#DFE0FF] text-secondary dark:text-white rounded-full">{{ emailsCount }}</span>
                </div>
              </div>

              <div class="flex items-center">
                <div class="flex justify-center items-center">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="text-secondary dark:text-primary-200 size-6 mr-2">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 0 0 2.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 0 1-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 0 0-1.091-.852H4.5A2.25 2.25 0 0 0 2.25 4.5v2.25Z" />
                  </svg>
                  <span class="flex justify-center items-center text-xs h-7 w-7 bg-[#DFE0FF]/10 border border-[#DFE0FF] text-secondary dark:text-white rounded-full">{{ phoneNumbersCount }}</span>
                </div>

                <div class="ml-3 h-5 border-r border-[#DFE0FF]"></div>
              </div>

                <a *ngIf="report.linkedin_url" href="{{ report.linkedin_url }}" target="_blank" class="flex justify-center items-center">
                  <span class="flex justify-center items-center text-xs h-7 w-7 bg-[#DFE0FF]/0 border border-[#DFE0FF] rounded-full p-1">
                    <svg viewBox="0 0 14 13" fill="none" class="h-5 w-5 fill-secondary dark:fill-white">
                        <path d="M12.25 0.625C12.7148 0.625 13.125 1.03516 13.125 1.52734V12C13.125 12.4922 12.7148 12.875 12.25 12.875H1.72266C1.25781 12.875 0.875 12.4922 0.875 12V1.52734C0.875 1.03516 1.25781 0.625 1.72266 0.625H12.25ZM4.56641 11.125V5.30078H2.76172V11.125H4.56641ZM3.66406 4.48047C4.23828 4.48047 4.70312 4.01562 4.70312 3.44141C4.70312 2.86719 4.23828 2.375 3.66406 2.375C3.0625 2.375 2.59766 2.86719 2.59766 3.44141C2.59766 4.01562 3.0625 4.48047 3.66406 4.48047ZM11.375 11.125V7.92578C11.375 6.36719 11.0195 5.13672 9.1875 5.13672C8.3125 5.13672 7.71094 5.62891 7.46484 6.09375H7.4375V5.30078H5.71484V11.125H7.51953V8.25391C7.51953 7.48828 7.65625 6.75 8.61328 6.75C9.54297 6.75 9.54297 7.625 9.54297 8.28125V11.125H11.375Z" />
                    </svg>
                  </span>
                </a>

                <a  *ngIf="report.twitter_url" href="{{ report.twitter_url }}" target="_blank" class="flex justify-center items-center">
                    <span class="flex justify-center items-center text-xs h-7 w-7 border border-[#DFE0FF] rounded-full">
                        <svg viewBox="0 0 14 12" fill="none" class="h-5 w-5 fill-[#6C73AB] dark:fill-white">
                            <path d="M12.5508 2.90625C12.5508 3.04297 12.5508 3.15234 12.5508 3.28906C12.5508 7.08984 9.67969 11.4375 4.40234 11.4375C2.76172 11.4375 1.25781 10.9727 0 10.1523C0.21875 10.1797 0.4375 10.207 0.683594 10.207C2.02344 10.207 3.25391 9.74219 4.23828 8.97656C2.98047 8.94922 1.91406 8.12891 1.55859 6.98047C1.75 7.00781 1.91406 7.03516 2.10547 7.03516C2.35156 7.03516 2.625 6.98047 2.84375 6.92578C1.53125 6.65234 0.546875 5.50391 0.546875 4.10938V4.08203C0.929688 4.30078 1.39453 4.41016 1.85938 4.4375C1.06641 3.91797 0.574219 3.04297 0.574219 2.05859C0.574219 1.51172 0.710938 1.01953 0.957031 0.609375C2.37891 2.33203 4.51172 3.48047 6.89062 3.61719C6.83594 3.39844 6.80859 3.17969 6.80859 2.96094C6.80859 1.375 8.09375 0.0898438 9.67969 0.0898438C10.5 0.0898438 11.2383 0.417969 11.7852 0.992188C12.4141 0.855469 13.043 0.609375 13.5898 0.28125C13.3711 0.964844 12.9336 1.51172 12.332 1.86719C12.9062 1.8125 13.4805 1.64844 13.9727 1.42969C13.5898 2.00391 13.0977 2.49609 12.5508 2.90625Z" />
                        </svg>
                    </span>
                </a>


                <a *ngIf="reportSearch.facebook_url" href="{{ reportSearch.facebook_url }}" target="_blank" class="flex justify-center items-center">
                    <span class="flex justify-center items-center text-xs h-7 w-7 border border-[#DFE0FF] rounded-full">
                        <svg viewBox="0 0 14 15" fill="none" class="h-5 w-5 fill-[#6C73AB] dark:fill-white">
                            <path d="M13.7812 7.75C13.7812 11.1406 11.293 13.957 8.03906 14.4492V9.71875H9.625L9.92578 7.75H8.03906V6.49219C8.03906 5.94531 8.3125 5.42578 9.16016 5.42578H10.0078V3.75781C10.0078 3.75781 9.24219 3.62109 8.47656 3.62109C6.94531 3.62109 5.93359 4.57812 5.93359 6.27344V7.75H4.21094V9.71875H5.93359V14.4492C2.67969 13.957 0.21875 11.1406 0.21875 7.75C0.21875 4.00391 3.25391 0.96875 7 0.96875C10.7461 0.96875 13.7812 4.00391 13.7812 7.75Z" />
                        </svg>
                    </span>
                </a>

            </div>
            -->

            <!-- Description -->
            <div class="mb-0 relative">

              <!-- Edit Prompt -->
              <!--
              <button type="button"
                      (click)="handleEditPrompt('ASK_ASSISTANT_PERSONAL_BACKGROUND', personal_background)"
                      class="absolute top-1 right-1 rounded-md bg-[#1c9ed1]/10 p-1 text-white hover:bg-opacity-90 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-transparent"
                      matTooltip="Edit"
                      matTooltipPosition="above"
                      matTooltipClass="'custom-tooltip'"
              >
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="text-[#1c9ed1] h-3 w-3">
                  <path d="M21.731 2.269a2.625 2.625 0 0 0-3.712 0l-1.157 1.157 3.712 3.712 1.157-1.157a2.625 2.625 0 0 0 0-3.712ZM19.513 8.199l-3.712-3.712-12.15 12.15a5.25 5.25 0 0 0-1.32 2.214l-.8 2.685a.75.75 0 0 0 .933.933l2.685-.8a5.25 5.25 0 0 0 2.214-1.32L19.513 8.2Z" />
                </svg>
              </button>
              -->

                <div *ngIf="company" class="flex justify-between w-full">
                    <div class="flex flex-col justify-between gap-y-2 h-[4rem] max-h-[4rem] mt-1">
                      <!--
                      <p [innerHTML]="personal_background" class="text-sm h-10 text-secondary dark:text-white line-clamp-2"></p>
                      -->
                      <!--
                      <p class="text-sm h-10 text-secondary dark:text-white line-clamp-2" [innerHTML]="personalBackground"></p>
                      -->

                      <app-assistant-prompt tag="ASK_ASSISTANT_PERSONAL_BACKGROUND"
                                            title="Personal background"
                                            [type]="'insights'"
                                            [company]="company"
                                            [reportId]="report?.id"
                                            [showButton]="true"
                                            [buttonType]="1"
                                            [class]="'line-clamp-2'">
                      </app-assistant-prompt>

                    </div>

                </div>
            </div>
            <!-- / Description -->

        </div>

    </div>
</div>
